module.exports = __webpack_public_path__ + "static/media/icon_add_patient.22522579.svg";